import { FleekError } from './FleekError';

type FleekRestApiInternalErrorOptions = {
  message: string;
};

export class FleekRestApiInternalError extends FleekError<FleekRestApiInternalErrorOptions> {
  public name = 'FleekRestApiInternalError';

  toString = () => this.data.message;
}
